export const stringEmpty = (t: string | undefined) => {
  if (t == undefined || t == "" || t == null) {
    return true;
  }
  return false;
};

export const envVariableEmpty = (t: string | undefined) => {
  //Método temporal, la idea es detectar si están las let de ambiente no existen
  if (t == undefined) {
    try {
      throw new Error("Variable ambiente vacía");
    } catch (e) {
      console.error(e);
    }
  }
  return t || "";
};
